import { gql } from 'apollo-boost';

export const GET_CLASSROOM_STATS = gql`
  query getClassroomStats($id: ID) {
    getClassroomStats (
      id: $id
    ) {
      id
      seriesTotalStudentInEachUnits {
        id
        name
        data
      }
      seriesStudentAccess {
        name
        data { x, y }
      }
    }
  }
`;
